import util from '../util'

let controller = 'QueueEnvioPix'
export default Object.assign({}, {
  ComboCodigosMensagem: function () {
    return util.Axios.Get(controller + '/ComboCodigosMensagem')
  },
  GetAll: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller, dto)
  }
})
